export default {"src":"/_next/static/media/nimbleMotors.f2ec796b.svg","height":48,"width":122,"blurWidth":0,"blurHeight":0};